export default {
  DatePicker: {
    lang: {
      locale: 'zh-tw',
      placeholder: '請選擇日期',
      rangePlaceholder: ['開始日期', '結束日期'],
      today: '今天',
      now: '現在',
      backToToday: '返回今天',
      ok: '確定',
      clear: '清除',
      month: '月',
      year: '年',
      timeSelect: '選擇時間',
      dateSelect: '選擇日期',
      monthSelect: '選擇月份',
      yearSelect: '選擇年份',
      decadeSelect: '選擇年代',
      yearFormat: 'YYYY年',
      dateFormat: 'YYYY年M月D日',
      dayFormat: 'D日',
      dateTimeFormat: 'YYYY年M月D日 HH:mm:ss',
      monthFormat: 'M月',
      monthBeforeYear: true,
      previousMonth: '上個月',
      nextMonth: '下個月',
      previousYear: '上一年',
      nextYear: '下一年',
      previousDecade: '上一個十年',
      nextDecade: '下一個十年',
      previousCentury: '上一個世紀',
      nextCentury: '下一個世紀',
      shortWeekDays: ['日', '一', '二', '三', '四', '五', '六'],
      shortMonths: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
      ],
      fullWeekDays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      fullMonths: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
      ],
    },
    timePickerLocale: {
      placeholder: '請選擇時間',
    },
  },
}
